import React from "react";
import DeckView from "./components/DeckView";
import "./App.css";

function App() {
  return (
    <div className="App" style={{ padding: "2rem" }}>
      <h1 className="sitetitle">Spaced</h1>
      <DeckView />
    </div>
  );
}

export default App;
